/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import FormField from "components/FormField";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SwitchField from "components/SwitchField";

export default function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { checkbox1, checkbox2, organizeName, taxId, organ1, organ2 } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox1.name} label={checkbox1.label} value={values.checkbox1} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox2.name} label={checkbox2.label} value={values.checkbox2} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={organizeName.type}
            name={organizeName.name}
            label={organizeName.label}
            value={values.organizeName}
            error={errors.organizeName && touched.organizeName}
            success={values.organizeName?.toString().length > 0 && !errors.organizeName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={taxId.type}
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={organ1.type}
            name={organ1.name}
            label={organ1.label}
            value={values.organ1}
            error={errors.organ1 && touched.organ1}
            success={values.organ1?.toString().length > 0 && !errors.organ1}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={organ2.type}
            name={organ2.name}
            label={organ2.label}
            value={values.organ2}
            error={errors.organ2 && touched.organ2}
            success={values.organ2?.toString().length > 0 && !errors.organ2}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftBox ml={0.5} lineHeight={0} display="inline-block">
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              4. Thông tin đăng ký thuế/thông tin thay đổi của cá nhân có ủy quyền như sau:
            </SoftTypography>
          </SoftBox>
        </Grid>
      </Grid>
    </Box>
  );
}
